import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import type { CargoTripRes, TEntityIdRes, UpdateTripReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { CARGO_TRIPS_MANY, TRIP_GET_ONE, CARGO_ITEMS_MANY, TRIP_ARRIVAL_INFORMATION } from '../query-keys.ts';

export const useUpdateTrip = (tripId: number) => {
  const queryClient = useQueryClient();

  return useMutationBase<TEntityIdRes, unknown, UpdateTripReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TEntityIdRes>(`/v1/trips/${tripId}`, variables);
      return res.data;
    },

    invalidateCallback: () => {
      const cargoTrips: CargoTripRes[] | undefined = queryClient.getQueryData([CARGO_TRIPS_MANY, tripId]);
      const cargoIds = cargoTrips ? cargoTrips.map((cargoTrip: CargoTripRes) => cargoTrip.cargoId) : [];

      return [
        [TRIP_GET_ONE, tripId],
        [TRIP_ARRIVAL_INFORMATION, tripId],
        [CARGO_TRIPS_MANY, tripId],
        ...cargoIds.map((cargoId) => [CARGO_ITEMS_MANY, cargoId]),
      ];
    },
  });
};
